var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.item,on:{"click":_vm.handleSelect}},[_vm._t("default",null,{"select":_vm.handleSelect,"hasSelectedChildren":_vm.hasSelectedChildren,"hasChildren":_vm.hasChildren,"selected":_vm.selected})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }